export default function(){
    (function($) {

        $('.masonry').isotope({
            itemSelector: '.masonry-item',
            percentPosition: true,
            masonry: {
                columnWidth: '.masonry-sizer',
                gutter: 15,
            }
        })


    })(jQuery);
}
